// extracted by mini-css-extract-plugin
export var acceptButton = "_3i-5";
export var fullContent = "_3i-4";
export var link = "_3i-6";
export var linkIcon = "_3i-7";
export var sideContent = "_3i-3";
export var sideImage = "_3i-2";
export var sideImageWrapper = "_3i-1";
export var splitLayout = "_3i-0";